import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreOrganizationSectionPassCoupon,
} from '../firestore/OrganizationSectionPassCoupon/schema'

export class OrganizationSectionPassCoupon extends ObservableModelWithDecorators<FirestoreOrganizationSectionPassCoupon> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreOrganizationSectionPassCoupon>
  ) {
    super(repository, doc)
  }
}
